module.exports = __webpack_public_path__ + "img/1682b40c5e10c9dd5726bde79aea0d3.d09f3cb2.jpg";